<script>
export default {
    name: 'GeneTrackerLink',
}
</script>
<template>
  <a target="gene-tracker" href="https://gene-tracker.clinicalgenome.org">
    <slot>Gene Tracker</slot>
  </a>
</template>